import React from "react";
import FeatureHeader from "../components/FeatureHeader";
import Icon from "../components/Icon";
import VolunteerForm from "../components/VolunteerForm";
import SocialLinks from "../components/SocialLinks";
import "./BusyBees.css";

const VOLUNTEER_EMAIL = "volunteer@bugandfrog.org";

const supplies = [
  {
    icon: "handCoins",
    title: "All the funding",
    description: "Every cost is covered by the foundation, so you never spend a dime to volunteer with us."
  },
  {
    icon: "scissors",
    title: "All the crafting supplies",
    description:
      "Yarn, fabric, thread, patterns, and tools: everything you need to stitch, crochet, knit, or craft."
  },
  {
    icon: "cookie",
    title: "All the snacks",
    description: "Coffee, treats, and good company. Just bring your hands and your heart."
  }
];

// Chip colors cycle green → white → beige, as in the design.
const makes = [
  "Baby blankets",
  "Hats and booties",
  "Scent hearts",
  "Burp cloths",
  "NICU octopuses",
  "Comfort loveys",
  "Keepsakes"
];
const CHIP_TONES = ["green", "white", "beige"];

export default function BusyBees() {
  return (
    <div className="busy-bees">
      <FeatureHeader badge="Crafters wanted" icon="sparkles" title="Busy Bees">
        Our volunteer crafting community, making handmade comfort for NICU and PICU families. If you can craft, we'd love your hands. No experience or supplies needed. You bring the creativity; we take care of everything else.
      </FeatureHeader>

      <div className="bb-hero-action">
        <a href="#join" className="btn">
          Become a Busy Bee <Icon name="arrowRight" size={16} />
        </a>
      </div>

      <section>
        <div className="container bb-narrow">
          <div className="bb-supplies">
            <div className="bb-section-heading">
              <h2>We supply everything</h2>
              <p>Show up as you are. The foundation covers the rest.</p>
            </div>
            <ul className="bb-supply-list">
              {supplies.map((item) => (
                <li className="bb-supply-row" key={item.title}>
                  <span className="bb-icon-circle">
                    <Icon name={item.icon} size={32} />
                  </span>
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section>
        <div className="container bb-narrow">
          <div className="bb-section-heading">
            <h2>What you'll make</h2>
            <p>Handmade with love, delivered where it matters most.</p>
          </div>
          <ul className="bb-chips">
            {makes.map((item, index) => (
              <li key={item} className={`bb-chip bb-chip-${CHIP_TONES[index % CHIP_TONES.length]}`}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="bb-join-section" id="join">
        <div className="container bb-join">
          <h2>Sign up</h2>
          <p>Tell us a little about yourself and we'll be in touch.</p>
          <VolunteerForm />

          <SocialLinks email={VOLUNTEER_EMAIL} className="bb-social" />
        </div>
      </section>
    </div>
  );
}
